module.exports = __webpack_public_path__ + "img/sogou.3111b480.png";